// :cow: Cosmose CONFIDENTIAL :iso:
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app.component';
import { initialState, REDUCER_TOKEN, reducerProvider } from './store';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './shared/modules/layout/layout.module';
import { AuthModule } from './auth/auth.module';
import { AuthInterceptor } from './auth/shared/auth.interceptor';
import { ErrorsModule } from './errors/errors.module';
import { CampaignService } from '@med/app/home/campaign/services/campaign.service';
import { GoogleAnalyticsService } from './core/services/google-analytics/google-analytisc.service';
import { LanguageModule } from '@med/app/core/language/language.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LanguageInterceptor } from '@med/app/core/language/service/language.interceptor';
import { errorHandlerFactory } from '@med/app/core/error-handler/error-handler.factory';
import { ConfigService } from '@med/app/core/config/config.service';
import { PopupModule } from '@med/app/shared/modules/popup/popup.module';
import { SpinnerService } from '@med/app/core/services/spinner.service';
import { ButtonModule } from '@med/app/shared/modules/button/button.module';
import { MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { environment } from '@med/environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthEffects } from '@med/app/auth/store/auth.effects';
import { AdFormatService } from '@med/app/shared/modules/ad-format/services/ad-format.service';
import { GuidedTourModule } from '@med/app/home/demo/guided-tour/guided-tour.module';
import { CommonModule } from '@angular/common';
import { PlannerBasicDemoInterceptor } from '@med/app/home/planner-basic-demo/planner-basic-demo.interceptor';
import { PlannerFullDemoInterceptor } from '@med/app/home/planner-full-demo/planner-full-demo.interceptor';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot(),
    AuthModule,
    LayoutModule,
    ErrorsModule,
    StoreModule.forRoot(REDUCER_TOKEN, {initialState}),
    EffectsModule.forRoot([
      AuthEffects,
    ]),
    StoreRouterConnectingModule.forRoot(),
    environment.production ? [] : [StoreDevtoolsModule.instrument({maxAge: 50})],
    LanguageModule,
    GuidedTourModule,
    PopupModule,
    ButtonModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-full-width',
      timeOut: 8000,
      closeButton: true,
    }),
    NgxSpinnerModule,
  ],
  providers: [
    CampaignService,
    AdFormatService,
    reducerProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PlannerBasicDemoInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PlannerFullDemoInterceptor,
      multi: true,
    },
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true},
    GoogleAnalyticsService,
    {
      provide: ErrorHandler,
      useFactory: errorHandlerFactory,
      deps: [ConfigService],
    },
    {provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig},
    SpinnerService,
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true}},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
